var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"con-wrap"},[_c('h1',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.sectionTitle))]),_c('img',{staticClass:"section-bg",attrs:{"src":_vm.imgSrc,"alt":_vm.sectionTitle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }